module.exports = __webpack_public_path__ + "img/login_fail.575afa4f.png";